"use strict";
var import_setServerGlobals = require("./setServerGlobals");
(0, import_setServerGlobals.setServerGlobals)();
//# sourceMappingURL=setupServerGlobals.js.map
